import React, { Component } from "react";
import { Table, DatePicker, Button, Form, Select, message } from 'antd'
import moment from 'moment'
import { getOrganizationWorkList, exportOrganizationWorkList } from '@/request/api'
import { requestErrorLog } from "@/common/util";


const { Option } = Select;
// 开始日期-结束日期
const defaultSelectDate = {
  startDate: moment().startOf('day').subtract(29, 'days'),
  endDate: moment().endOf('day')
};

class OrganizationWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataStats: "",
      hospitalList: [],
      tableList: [],
      hospitalCode: '',
      selectPriceDate: '',
      offsetDays: 31536000000 * 5,
      startTime: '',
      endTime: '',
    }
  }

  componentDidMount() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.setState({
      hospitalCode: userInfo.HOSPITAL_CODE
    }, () => {
      this.handleSubmit()
      this.initHospitalList(userInfo)
    })
  }

  handleSubmit = (type) => {
    this.props.form.validateFields((err, values) => {
      if (values.startTime > values.endTime) {
        message.error('开始时间不得大于结束时间')
        return;
      }
      this.setState({
        startTime: moment(values.startTime).format('YYYY.MM.DD'),
        endTime: moment(values.endTime).format('YYYY.MM.DD')
      })
      let params = {
        HOSPITAL_CODE: this.state.hospitalCode,
        hospitalDateTime: [moment(values.startTime).format('YYYY-MM-DD'), moment(values.endTime).format('YYYY-MM-DD')],
      }
      if (type === 'export') {
        exportOrganizationWorkList(params).then(res => {
          if (res && res.Status === 1) {
            window.location.href = window.g.baseURL + "\\" + res.Result;
          }else {
            requestErrorLog('', '数据统计-机构工作量统计列表导出报错', 0,true)
          }
        })
      } else {
        getOrganizationWorkList(params).then(res => {
          if (res && res.Status === 1) {
            let total = res.Result.total;
            let obj = {
              "HOSPITAL_NAME": "合计",
              "HOSPITAL_CODE": 'heji',
              "HOLTERSUM": total.LOCAL_HOLTE_TOTAL,
              "ECGSUM": total.LOCAL_ECG_TOTAL,
              "BPSUM": total.LOCAL_BP_TOTAL,
              "NOCHECKSUM": total.LOCAL_TOTAL,
              "CHECKHOLTERSUM": total.CHECK_HOLTE_TOTAL,
              "CHECKECGSUM": total.CHECK_ECG_TOTAL,
              "CHECKBPSUM": total.CHECK_BP_TOTAL,
              "CHECKTOTAL": total.CHECKED_TOTAL,
            }
            res.Result.data.push(obj)
            this.setState({
              tableList: res.Result.data
            })
          }else {
            requestErrorLog('', '数据统计-机构工作量统计列表报错', 0,true)
          }
        })
      }

    });
  }


  selectHospital = (value) => {
    this.setState({
      hospitalCode: value
    })
  }

  disabledDate = (current) => {
    if (this.state.selectPriceDate) {
      let selectV = moment(this.state.selectPriceDate, 'YYYY-MM-DD').valueOf()
      return current > moment(new Date(selectV + this.state.offsetDays).getTime()) ||
        current < moment(new Date(selectV - this.state.offsetDays).getTime()) ||
        current > moment().endOf('day')
    } else {
      return current > moment().endOf('day')
    }
  }
  changeRangePicker = (e) => {
    this.setState({
      selectPriceDate: ''
    })
  }
  calendarPriceRangeChange = (date) => {
    this.setState({
      selectPriceDate: date[0]
    })
  }

  initHospitalList(userInfo) {

    this.setState({
      hospitalList: [{
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        HOSPITAL_NAME: userInfo.HOSPITAL_NAME
      }]
    })

  }
  handleCheckTypeValue = (checkedValues) => {
    this.setState({
      checkedType: checkedValues
    })
  }
  render() {
    const { form: { getFieldDecorator } } = this.props;
    const { tableList, hospitalList, startTime, endTime } = this.state;
    const columns = [
      {
        title: '',
        ellipsis: true,
        width: 200,
        children: [
          {
            title: '机构/科室名称',
            dataIndex: 'HOSPITAL_NAME',
            key: 'HOSPITAL_NAME',
            ellipsis: true,
            width: 200,
            align: 'center'
          }
        ]
      },
      {
        title: '未审核病例量',
        children: [
          {
            title: '动态心电',
            dataIndex: 'HOLTERSUM',
            key: 'HOLTERSUM',
            align: 'center'
          },
          {
            title: '动态血压',
            dataIndex: 'BPSUM',
            key: 'BPSUM',
            align: 'center'
          },
          {
            title: '静息心电',
            dataIndex: 'ECGSUM',
            key: 'ECGSUM',
            align: 'center'
          },
          {
            title: '合计',
            dataIndex: 'NOCHECKSUM',
            key: 'NOCHECKSUM',
            align: 'center'
          },
        ]
      },
      {
        title: '已审核病例量',
        children: [
          {
            title: '动态心电',
            dataIndex: 'CHECKHOLTERSUM',
            key: 'CHECKHOLTERSUM',
            align: 'center'
          },
          {
            title: '动态血压',
            dataIndex: 'CHECKBPSUM',
            key: 'CHECKBPSUM',
            align: 'center'
          },
          {
            title: '静息心电',
            dataIndex: 'CHECKECGSUM',
            key: 'CHECKECGSUM',
            align: 'center'
          },
          {
            title: '合计',
            dataIndex: 'CHECKTOTAL',
            key: 'CHECKTOTAL',
            align: 'center'
          },
        ]
      },
    ]
    return (
      <>
        <Form layout="inline" style={{ minWidth: "1260px" }}>
          <Form.Item label="日期选择" className="headerlable">
            {getFieldDecorator('startTime', { initialValue: defaultSelectDate.startDate })(
              <DatePicker
                style={{ width: 145 }}
                allowClear={false}
                placeholder='开始日期'
                disabledDate={this.disabledDate}
              />)}
            <span style={{ display: 'inline-block', textAlign: 'center', width: 15 }}>-</span>
            <Form.Item style={{ width: 110 }}>
              {getFieldDecorator('endTime', { initialValue: defaultSelectDate.endDate })(
                <DatePicker
                  style={{ width: 145 }}
                  allowClear={false}
                  placeholder='结束日期'
                  disabledDate={this.disabledDate}
                />)}
            </Form.Item>
          </Form.Item>
          <Form.Item label="机构/科室">
            {getFieldDecorator("hospitalCode", { rules: [{ required: true, message: '机构/科室名称不能为空！' }], initialValue: this.state.hospitalCode })(
              <Select style={{ width: 260 }} onChange={this.selectHospital} disabled>
                {hospitalList && hospitalList.map((item) => {
                  return <Option value={item.HOSPITAL_CODE} key={item.HOSPITAL_CODE}>{item.HOSPITAL_NAME}</Option>
                })}
              </Select>
            )}
          </Form.Item>
          <Button style={{ marginLeft: '10px', marginTop: '4px' }} onClick={this.handleSubmit}>查询</Button>
          <Button style={{ marginLeft: '10px', marginTop: '4px' }} onClick={this.handleSubmit.bind(this, 'export')}>导出</Button>
        </Form>
        <div className="wrap statisticsTableBox" style={{ minWidth: "1260px" }}>
          <Table
            columns={columns}
            dataSource={tableList}
            bordered
            rowKey={(record) => record.HOSPITAL_CODE} // 需要修改为唯一的ID！
            pagination={false}
            scroll={{ y: 640 }}
            title={() => (
              <div className="tableHeader">
                <p>查询日期：{startTime} --- {endTime}</p>
              </div>
            )}
          >

          </Table>
        </div>
      </>
    );
  }
}

export default Form.create()(OrganizationWork);
